import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';

// Navigation items with role requirements
const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard', icon: '⊞', path: '/dashboard', roles: ['admin', 'nurse_manager', 'nurse', 'caregiver', 'staff'] },
  { id: 'residents', label: 'Residents', icon: '👥', path: '/residents', roles: ['admin', 'nurse_manager', 'nurse', 'caregiver', 'staff'] },
  { id: 'emar', label: 'eMAR', icon: '💊', path: '/emar', roles: ['admin', 'nurse_manager', 'nurse', 'caregiver'] },
  { id: 'staff', label: 'Staff & HR', icon: '🪪', path: '/staff', roles: ['admin', 'nurse_manager'] },
  { id: 'timeclock', label: 'Time Clock', icon: '⏱', path: '/timeclock', roles: ['admin', 'nurse_manager', 'nurse', 'caregiver', 'staff'] },
  { id: 'billing', label: 'Billing', icon: '💳', path: '/billing', roles: ['admin', 'nurse_manager'] },
  { id: 'assessments', label: 'Assessments', icon: '📋', path: '/assessments', roles: ['admin', 'nurse_manager', 'nurse'] },
  { id: 'careplans', label: 'Care Plans', icon: '📄', path: '/careplans', roles: ['admin', 'nurse_manager', 'nurse'] },
  { id: 'documents', label: 'Documents', icon: '📁', path: '/documents', roles: ['admin', 'nurse_manager', 'nurse'] },
  { id: 'reports', label: 'Reports', icon: '📊', path: '/reports', roles: ['admin', 'nurse_manager'] },
  { id: 'settings', label: 'Settings', icon: '⚙️', path: '/settings', roles: ['admin'] },
  { id: 'account', label: 'Account', icon: '👤', path: '/account', roles: ['admin', 'nurse_manager', 'nurse', 'caregiver', 'staff'] },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();
  const { B } = useTheme();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  // Get current path
  const currentPath = location.pathname;

  // Filter navigation based on user role
  const visibleNavItems = NAV_ITEMS.filter(item => 
    item.roles.includes(user?.role)
  );

  return (
    <aside style={{
      width: '220px',
      background: B.sidebarBg,
      borderRight: `1px solid ${B.border}`,
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      overflowY: 'auto',
      height: 'calc(100vh - 54px)',
      position: 'sticky',
      top: '54px'
    }}>
      <nav style={{ padding: '12px 8px', flex: 1 }}>

        {visibleNavItems.map(item => {
          const active = currentPath === item.path;
          return (
            <button 
              key={item.id} 
              onClick={() => handleNavigate(item.path)} 
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '10px 12px',
                borderRadius: 8,
                border: 'none',
                cursor: 'pointer',
                fontFamily: 'inherit',
                textAlign: 'left',
                marginBottom: 0,
                background: active ? `${B.green}15` : 'transparent',
                transition: 'background 0.2s',
                color: B.text
              }}
            >
              <span style={{ fontSize: '1rem' }}>{item.icon}</span>
              <span style={{
                fontSize: 13,
                fontWeight: active ? 700 : 500,
                color: active ? B.green : B.text
              }}>{item.label}</span>
            </button>
          );
        })}
      </nav>

      <div style={{ padding: '12px 8px', borderTop: `1px solid ${B.border}` }}>
        {/* <div style={{
          padding: '8px 10px',
          marginBottom: 8,
          background: B.bg,
          borderRadius: 8,
          fontSize: 10,
          color: B.muted
        }}>
          <div style={{ fontWeight: 700, color: B.text }}>{user?.name}</div>
          <div style={{ textTransform: 'capitalize' }}>{user?.role?.replace('_', ' ')}</div>
        </div> */}
        <button onClick={handleLogout} style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',  // centers the text horizontally
          gap: 10,
          padding: '10px 12px',
          borderRadius: 8,
          border: 'none',
          cursor: 'pointer',
          fontFamily: 'inherit',
          background: '#fee2e2',
          color: '#dc2626',
          fontWeight: 600,
          fontSize: 13
        }}>
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}